(function () {
    function activateTab(tab, section) {
        const target = tab.getAttribute('data-target');
        const tabs = section.querySelectorAll('.contact-tabs__tab');
        const panels = section.querySelectorAll('.contact-tabs__panel');

        const panel = section.querySelector(target);
        if (!panel) return false;

        tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function (p) {
            p.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        panel.classList.add('is-active');

        try {
            history.pushState(null, '', '#' + tab.id);
        } catch (e) {
            window.location.hash = tab.id;
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
        return true;
    }

    function initSection(section) {
        const tabs = section.querySelectorAll('.contact-tabs__tab');

        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                activateTab(tab, section);
            });

            tab.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    activateTab(tab, section);
                }
            });
        });
    }

    function activateFromFragment() {
        const hash = (window.location.hash || '').replace('#', '');
        const targetBtn = document.getElementById(hash);

        if (targetBtn && targetBtn.classList.contains('contact-tabs__tab')) {
            const section = targetBtn.closest('.contact-tabs');
            if (section) {
                activateTab(targetBtn, section);
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            document.querySelectorAll('.contact-tabs').forEach(initSection);
            activateFromFragment();
            window.addEventListener('hashchange', activateFromFragment);
        });
    } else {
        document.querySelectorAll('.contact-tabs').forEach(initSection);
        activateFromFragment();
        window.addEventListener('hashchange', activateFromFragment);
    }
})();
